import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DragItem } from "./DragItem";

export function SortableItem({ id, children, className, isDraggable }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: id, disabled: !isDraggable });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <DragItem
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={className}
    >
      {children}
    </DragItem>
  );
}
